import {Trans, useTranslation} from "react-i18next";
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow
} from "@material-ui/core";
import {formatCurrency} from "../../../utils";
import Button from "@material-ui/core/Button";
import React, {useMemo} from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {usePriceList} from "../../Providers/PriceListProvider";
import {upperCaseFirst} from "../../../lib/common";

const useStyles = makeStyles((theme) => ({
    priceCell: {
      //  textAlign: 'right'
    },
    oldPrice: {
        textDecoration: 'line-through'
    },
    productTable: {
        '& > thead > tr > th': {
            backgroundColor: '#E4E4E4',
            textAlign: 'center',
            fontWeight: 'normal',
            padding: theme.spacing(1)
        },
        '& > tbody > tr > td': {
            textAlign: 'center'
        }
    },
    dialogContent: {
        paddingLeft: 0,
        paddingRight: 0,
        '& h4': {
            textAlign: 'center',
            marginBottom: theme.spacing(1),
            marginTop: theme.spacing(3),
        }
    },
    campaignText: {
        marginTop: 0,
        textAlign: 'center'
    }
}));

export default ({product, category, categories=[], open, handleClose}) => {
    const classes = useStyles();
    const [t] = useTranslation();
    const { productHasCampaign } = usePriceList();

    const hasCampaign = useMemo( () => {
        if (!product) {
            return false;
        }

        if (productHasCampaign(product, category)) {
            return true;
        }

        if (categories) {
            for (const category of categories) {
                if (productHasCampaign(product, category)) {
                    return true;
                }
            }
        }
        return false;

    }, [product, category, categories]);

    if (!open) {
        return null;
    }

    let campaignPriceText = '';
    if (hasCampaign && product.campaignrequirement) {
       campaignPriceText = t('%s campaign!', {
           postProcess: 'sprintf',
           sprintf: [upperCaseFirst(t(product.campaignrequirement).toLowerCase())]
       })
    }
    else if (hasCampaign) {
        campaignPriceText = t('Campaign!');
    }


    return <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open}>
        <DialogTitle id="simple-dialog-title">{t("Prices %s", {
            postProcess: 'sprintf',
            sprintf: [product.name]
        })}</DialogTitle>
        <DialogContent className={classes.dialogContent}>
            {campaignPriceText && <p className={classes.campaignText}>{campaignPriceText}</p>}
            <ProductPrices product={product} hasCampaign={hasCampaign}/>
        </DialogContent>
        <DialogActions>
            <Button onClick={handleClose} color="primary" autoFocus>
                <Trans>Ok</Trans>
            </Button>
        </DialogActions>
    </Dialog>
}

const ProductPrices = ({hasCampaign, product}) => {
    if (product.subproducts.length == 0) {
        return <ProductPrice product={product} subproduct={null} hasCampaign={hasCampaign}/>
    } else {
        return product.subproducts.map(subProduct => {
            return <ProductPrice product={product} subProduct={subProduct} hasCampaign={hasCampaign}/>
        });
    }
}

const ProductPrice = ({product, hasCampaign, subProduct}) => {
    const [t] = useTranslation();
    const classes = useStyles();

    const prices = product.productprices.reduce( (prices, price) => {
        if (prices.length > 0) {
            prices[prices.length-1].quantityTo = price.quantity-1;
        }

        let campaignPrice = 0;
        let subProductPrice = 0;
        if (subProduct) {
            subProductPrice += subProduct.extraprice;
        }
        if (hasCampaign) {
            campaignPrice = price.campaignprice;
        }

        prices.push({
            quantityFrom: price.quantity,
            quantityTo: 0,
            price: price.price + subProductPrice,
            campaignPrice: campaignPrice + subProductPrice
        })
        return prices;
    }, []);

    let productName = product.name;
    if (subProduct) {
        productName += " " + subProduct.name;
    }

    return <>
        <h4>{productName}</h4>
        <Table className={classes.productTable}>
            <TableHead>
                <TableRow>
                    <TableCell><Trans>Quantity</Trans></TableCell>
                    <TableCell><Trans>Price/pcs</Trans></TableCell>
                    {hasCampaign && <TableCell><Trans>Campaign price</Trans></TableCell>}
                </TableRow>
            </TableHead>
            <TableBody>
                {prices.map((pp, index) => {
                    console.log('Product price', pp)
                    let qtyString = pp.quantityFrom;
                    if (pp.quantityTo) {
                        qtyString += '-' + pp.quantityTo;
                    } else {
                        qtyString += '+';
                    }
                    return <TableRow key={index}>
                        <TableCell>{t("%s pcs", {
                            postProcess: 'sprintf',
                            sprintf: [qtyString]
                        })}</TableCell>
                        <TableCell  className={hasCampaign ? classes.oldPrice : ''}>{formatCurrency(pp.price)}</TableCell>
                        {hasCampaign &&
                        <TableCell>{formatCurrency(pp.campaignPrice)}</TableCell>
                        }
                    </TableRow>
                })}
            </TableBody>
        </Table>
    </>
}